import moment from 'moment';
import Constants from "./Constants";

const Time = {

  durationToMoment(duration, format) {
    const m = (duration) ? moment.duration(duration) : undefined;
    const valueAsMoment = (duration) ? moment(`${m.hours()}:${m.minutes()}`, format) : undefined;
    return valueAsMoment;
  },

  dateTimeToDateForApi(datetime) {
    return moment(datetime).format(Constants.DATE_FORMAT_API);
  },

  dateTimeToTimeForApi(datetime) {
    return moment(datetime).format(Constants.TIME_FORMAT_API);
  },

  timeFromApiToDisplay(time) {
    return moment(time, Constants.TIME_FORMAT_API).format(Constants.TIME_FORMAT_DISPLAY)
  },

  timeFromDisplayToApi(time) {
    return moment(time, Constants.TIME_FORMAT_DISPLAY).format(Constants.TIME_FORMAT_API)
  },

  dateFromApiToDisplay(date) {
    return moment(date, Constants.DATE_FORMAT_API).format(Constants.DATE_FORMAT_DISPLAY)
  },

  dateFromDisplayToApi(date) {
    return moment(date, Constants.DATE_FORMAT_DISPLAY).format(Constants.DATE_FORMAT_API)
  },

  timeComparator(time1, time2) {
    return moment(time1, Constants.TIME_FORMAT_API).diff(moment(time2, Constants.TIME_FORMAT_API));
  },

  dateComparator(date1, date2) {
    return moment(date1, Constants.DATE_FORMAT_API).diff(moment(date2, Constants.DATE_FORMAT_API));
  },

  diffFromNow(date) {
    return moment(date).diff(moment(), 'hours');
  },

  beforeToday(date) {
    const currentDate = moment().format(Constants.DATE_FORMAT_API);
    return moment(currentDate).isAfter(date);
  },

  dayOfWeekAsStringUppercase(date){
    // moment().format('dddd');                    // Tuesday
    return moment(date).locale(Constants.LOCALES.en.locale).format('dddd').toUpperCase();
  },

};

export default Time;



// WEBPACK FOOTER //
// ./src/services/Time.js